import React, { FC } from 'react';
import { Panel } from '@component/Panel';
import { ASSETS_PATH } from '@app/react/const/variables';
import {
    OrderPartsHelpContents,
    Title,
    SubTitle,
    SubHeading,
    Paragraph,
    Image,
} from './OrderPartsHelpContents';
import { SakuraIcon } from './SakuraIcon';
import { OrderPartsHelpProps } from './type';
import { handleKeyPress } from './handleKeyPress';

const IMG_PATH = `${ASSETS_PATH}/img/order-help/nock`;

const nockData: Array<TableData> = [
    {
        kind: '筈の個数',
        about4: 4,
        about6: 6,
        about8: 8,
        about10: 10,
        about12: 12,
        about20: 20,
    },
    {
        kind: '予備の筈の個数',
        about4: 2,
        about6: 3,
        about8: 4,
        about10: 5,
        about12: 6,
        about20: 10,
    },
    {
        kind: '筈の合計数',
        about4: 6,
        about6: 9,
        about8: 12,
        about10: 15,
        about12: 18,
        about20: 30,
    },
];

type TableData = {
    kind: string;
    about4: number;
    about6: number;
    about8: number;
    about10: number;
    about12: number;
    about20: number;
};

const TableRow: FC<{ row: TableData }> = ({ row }) => (
    <tr className="table-row">
        <td className="text-align-center strong">{row.kind}</td>
        <td className="text-align-center">{row.about4}</td>
        <td className="text-align-center">{row.about6}</td>
        <td className="text-align-center">{row.about8}</td>
        <td className="text-align-center">{row.about10}</td>
        <td className="text-align-center">{row.about12}</td>
        <td className="text-align-center">{row.about20}</td>
    </tr>
);

const NockTable: FC<{ data: Array<TableData> }> = ({ data }) => (
    <table className="order-parts-help-table">
        <thead className="header">
            <tr>
                <th className="text-align-center">
                    <strong>ご注文の矢の本数</strong>
                </th>
                <th className="text-align-center">
                    <strong>4本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>6本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>8本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>10本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>12本セット</strong>
                </th>
                <th className="text-align-center">
                    <strong>20本セット</strong>
                </th>
            </tr>
        </thead>
        <tbody>
            {data.map((row, index) => (
                // eslint-disable-next-line react/no-array-index-key
                <TableRow key={index} row={row} />
            ))}
        </tbody>
    </table>
);

export const NockInner: FC<{ className?: string }> = ({ className }) => (
    <OrderPartsHelpContents className={className}>
        <Title>
            <SakuraIcon />
            筈の選び方
        </Title>

        <SubTitle>筈とは</SubTitle>
        <Paragraph>
            矢の上部（羽根の上側）に付いているのが筈です。シャフトのサイズや種類によって筈の種類が変わります。
        </Paragraph>

        <SubTitle>予備の筈について</SubTitle>
        <Paragraph>
            ご注文いただく矢の本数に応じて、下記のとおり予備の筈をお付けいたします。
        </Paragraph>
        <div className="overflow-x-scroll">
            <NockTable data={nockData} />
        </div>

        <SubTitle>筈について</SubTitle>
        <SubHeading>天弓筈</SubHeading>
        <Paragraph>
            強化プラスティックを使用。 ボンド不要です。
            耐衝撃性に優れている上、粘度があるので脱着時に根折れしにくい。
        </Paragraph>
        <Image src={`${IMG_PATH}/tenkyuhazu.png`} />

        <SubHeading>含み筈</SubHeading>
        <Paragraph>
            筈溝部分の加工がカギ状になっており、奥の部分が太くなっているので矢こぼれしにくい。
        </Paragraph>
        <Image src={`${IMG_PATH}/hukumihazu.png`} />

        <SubHeading>エンプラ筈</SubHeading>
        <Paragraph>
            ポリカーボネイト・耐喉材・ガラス繊維・着色剤を使用、耐衝撃性に優れている。
            溝構造が筈こぼれしないように奥側を多少太くしてある。
        </Paragraph>
        <Image src={`${IMG_PATH}/enpurahazu.png`} />

        <SubHeading>ストレート筈</SubHeading>
        <Paragraph>筈溝部分の加工が上から下まで同じ幅です。</Paragraph>
        <Image src={`${IMG_PATH}/straighthazu.png`} />
    </OrderPartsHelpContents>
);

export const OrderPartsHelpNock: FC<OrderPartsHelpProps> = ({
    isOpen,
    handleClose,
}) => (
    <Panel isOpen={isOpen} onRequestClose={handleClose}>
        <div
            className="order-parts-help-panel-close"
            onClick={handleClose}
            onKeyPress={handleKeyPress(handleClose)}
            role="button"
            tabIndex="0"
        >
            <i className="icon-close" />
        </div>
        <div className="order-parts-help-panel">
            <div className="scrollable">
                <NockInner />
            </div>
        </div>
    </Panel>
);
